import { ApolloQueryResult, OperationVariables } from '@apollo/client'
import {
  IconButton,
  Typography,
  useMediaQuery,
  useTheme
} from '@material-ui/core'
import RefreshIcon from '@material-ui/icons/Refresh'

import { getTranslate } from '../../localization'
import { PriceClass } from '../../types/priceClass'
import PriceClassRow from './PriceClassRow'
import PriceClassRowSkeleton from './PriceClassRow.skeleton'
import useStyles from './styles/PriceClassTable.styles'

interface PriceClassTableProps {
  data: PriceClass[]
  refetch: (variables?: Partial<OperationVariables> | undefined) => Promise<
    ApolloQueryResult<{
      priceClasses: PriceClass[]
    }>
  >
  loadingForGetPriceClassesList: boolean
}

export const PriceClassTable: React.FC<PriceClassTableProps> = ({
  data,
  refetch,
  loadingForGetPriceClassesList
}) => {
  const classes = useStyles()
  const theme = useTheme()
  const isSmallScreen = useMediaQuery(theme.breakpoints.down(768))
  return (
    <div className={classes.root}>
      <div className={classes.tableHead}>
        <div>
          <Typography variant="body1">{getTranslate('Name')}</Typography>
        </div>
        {!isSmallScreen && (
          <div>
            <Typography variant="body1">
              {getTranslate('Price Class')}
            </Typography>
          </div>
        )}
        <div>
          <Typography variant="body1">{getTranslate('Code')}</Typography>
        </div>
        {!isSmallScreen && (
          <>
            <div>
              <Typography variant="body1">
                {getTranslate('Input Currency')}
              </Typography>
            </div>
            <div>
              <Typography variant="body1">
                {getTranslate('Output Currency')}
              </Typography>
            </div>
            <div>
              <Typography variant="body1">
                {getTranslate('Archived At')}
              </Typography>
            </div>
          </>
        )}
        <div>
          <IconButton
            onClick={() => {
              refetch()
            }}>
            <RefreshIcon fontSize="small" />
          </IconButton>
        </div>
      </div>
      {loadingForGetPriceClassesList
        ? Array(5)
            .fill(null)
            .map((_, index) => (
              <PriceClassRowSkeleton
                key={`priceClass-row-skeleton${index.toString()}`}
                isSmallScreen={isSmallScreen}
              />
            ))
        : data.map((singlePriceClass) => (
            <PriceClassRow
              key={singlePriceClass.id}
              data={singlePriceClass}
              refetch={refetch}
              isSmallScreen={isSmallScreen}
            />
          ))}
    </div>
  )
}

export default PriceClassTable
